import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/task/importer/taskImporterActions';

export default importerReducers(actions);
